const conservation_area_reducer = (state = "", action) => {
	switch(action.type) {
		case 'SETCONSERVATIONAREA':
			return action.payload;

		default:
			return state;
	}
}

export default conservation_area_reducer;